
import i18n from '@/i18n'
export const tripType = {
	roundTrip: 0,
	oneWay: 1,
	returnOnly: 2
}

export const tripTypeArray = [
	{
		value: tripType.roundTrip,
		label: i18n.t('trip-type.round-trip')
	},
	{
		value: tripType.oneWay,
		label: i18n.t('trip-type.one-way')
	},
	{
		value: tripType.returnOnly,
		label: i18n.t('trip-type.return-only')
	}
]